<template>

  <data-form
    model="locations"
    :entity="model"
    :fields="locationFields"
    :after-submit="afterSubmit"
    :cancel="false"
  />

</template>

<script>
import locationFields from 'components/location/locationFields'

export default {
  name: 'location-form',
  data () {
    return {
      model: {
        id: 'new'
      },
      locationFields
    }
  },
  computed: {},
  methods: {
    afterSubmit () {
      this.$emit('next')
    }
  },
  beforeMount () {}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// LocationForm.vue?db1e95f4